import { dequal as deepEqual } from 'dequal'

export const convertTableStateToQuery = (tableState) => {
  const filters = Array.isArray(tableState?.columnFilters)
    ? tableState.columnFilters.reduce((acc, { id, value }) => {
        acc[id] = value
        return acc
      }, {})
    : {}

  const sortBy = Array.isArray(tableState?.sorting) && tableState.sorting.length > 0 ? tableState.sorting[0]?.id : ''
  const orderBy =
    Array.isArray(tableState?.sorting) && tableState.sorting.length > 0 ? (tableState.sorting[0]?.desc ? -1 : 1) : 1
  return {
    page: tableState?.pagination?.pageIndex ? tableState?.pagination?.pageIndex + 1 : 1,
    pageSize: tableState?.pagination?.pageSize ?? 10,
    sortBy: sortBy,
    orderBy: orderBy,
    filters: filters,
  }
}

export const applyLinkColumnFilters = (storedState, linkColumnFilters) => {
  if (!linkColumnFilters) {
    return storedState
  }

  return {
    ...storedState,
    columnFilters: linkColumnFilters,
    pagination: { ...storedState?.pagination, pageIndex: 0 },
  }
}

export const stripLinkColumnFilters = (nextState, linkColumnFilters, storedColumnFilters) => {
  if (!linkColumnFilters || !deepEqual(nextState?.columnFilters, linkColumnFilters)) {
    return null
  }

  return { ...nextState, columnFilters: storedColumnFilters ?? [] }
}

export const parseRangeFilter = (filterStr) => {
  if (!filterStr || typeof filterStr !== 'string') return { min: null, max: null }

  const parts = filterStr.split('to')
  if (parts.length !== 2) return { min: null, max: null }

  const minStr = parts[0].trim()
  const maxStr = parts[1].trim()

  const min = minStr === '' || minStr === '-' ? null : parseFloat(minStr)
  const max = maxStr === '' || maxStr === '-' ? null : parseFloat(maxStr)

  return {
    min: Number.isNaN(min) ? null : min,
    max: Number.isNaN(max) ? null : max,
  }
}

export const filterRange = (row, columnId, filterValue) => {
  const rowValue = row.getValue(columnId)
  const { min, max } = parseRangeFilter(filterValue)
  const value = parseFloat(rowValue)

  if (Number.isNaN(value)) return false
  if (min !== null && value < min) return false
  if (max !== null && value > max) return false

  return true
}
